import { IAppDataState } from '../../types/interfaces'
import { ActionType } from '../actions/actionTypes'
import initialState from './initialState'
export default function appDatareducer(state: IAppDataState = initialState.appData, action: any): IAppDataState {
  switch (action.type) {
    case ActionType.SET_USER:
      return { ...state, currentUser: action.user }
    case ActionType.SET_USER_PROPS:
      return { ...state, currentUser: state.currentUser ? { ...state.currentUser, ...action.props } : undefined }
    case ActionType.SET_MANAGER:
      return { ...state, selectedManager: action.manager }
    case ActionType.GET_APP_VERSION_SUCCESS:
      return { ...state, version: action.version }
    default:
      return state
  }
}
